import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from 'antd';
import './index.css';

const Field = ({ field, place }) => {
  const navigate = useNavigate();
  const { name, placeName, address, sport, descripcion, totalPlayers } = field;
  return (
    <Card
      className="card"
      hoverable
      onClick={() => navigate('/shifts', { state: { place, field } })}>
      <p>{placeName}</p>
      <p>{name}</p>
      <p>{address}</p>
      <p>{sport}</p>
      <p>{`Jugadores: ${totalPlayers}`}</p>
      <p>{descripcion}</p>
    </Card>
  );
};
export default Field;
